import {useContext} from "react"
import { UpdateReferantContext } from "./context"

export function useUpdateReferantHook() {
    return useContext(UpdateReferantContext);
}